import { IEditVehicleTypePayload, IGetVehicleTypeList, IVehicleTypeCreate, IVehicleTypeDetails, IVehicleTypeListSearch } from "../../../types/master/vehicleTypeInterface";
import { VehicleTypeActionTypes, VehicleTypeActions } from "../../actionTypes/master/vehicleTypeActionTypes";

export const createVehicleType = (payload: IVehicleTypeCreate): VehicleTypeActionTypes => ({
  type: VehicleTypeActions.CREATE_VEHICLE_TYPE,
  payload,
});

export const getVehicleTypeList = (payload: IVehicleTypeListSearch): VehicleTypeActionTypes => ({
  type: VehicleTypeActions.GET_VEHICLE_TYPE_LIST,
  payload,
});

export const setVehicleTypeList = (branchList: Array<IGetVehicleTypeList>) : VehicleTypeActionTypes => ({
  type: VehicleTypeActions.SET_VEHICLE_TYPE_LIST,
  payload: branchList
})

export const setVehicleTypeListPageCount = (payload:number): VehicleTypeActionTypes => ({
  type: VehicleTypeActions.SET_VEHICLE_TYPE_LIST_PAGE_COUNT,
  payload
})

export const getVehicleTypeDataById = (id: number): VehicleTypeActionTypes => ({
  type: VehicleTypeActions.GET_VEHICLE_TYPE_DATA_BY_ID,
  payload: id
})

export const setVehicleTypeDataById = (payload: IVehicleTypeDetails) => ({
  type: VehicleTypeActions.SET_VEHICLE_TYPE_DATA_BY_ID,
  payload
})

export const editVehicleType = (payload: IEditVehicleTypePayload) => ({
  type: VehicleTypeActions.EDIT_VEHICLE_TYPE_DATA_BY_ID,
  payload,
});
